"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OldBannerText = require("./OldBannerText");
Object.keys(_OldBannerText).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OldBannerText[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OldBannerText[key];
    }
  });
});